import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { MainService } from "src/app/app.service";

export interface TransferUsersResult {
  moved: number;
  notFound: Array<string>;
}

@Injectable()
export class UserTransferService {
  private readonly baseUrl = "/api/v2/users";

  constructor(
    private http: HttpClient,
    private mainService: MainService,
  ) {}

  /** Move os usuários para a área (id). */
  transfer(toArea: string, usernames: Array<string>): Observable<TransferUsersResult> {
    return this.http
      .patch<TransferUsersResult>(`${this.baseUrl}/area`, { toArea, usernames }, this.mainService.httpOptions)
      .pipe(tap(() => this.refreshSessionAreaIfSelf(usernames)));
  }

  transferAll(fromArea: string, toArea: string): Observable<TransferUsersResult> {
    return this.http
      .patch<TransferUsersResult>(`${this.baseUrl}/area`, { fromArea, toArea, all: true }, this.mainService.httpOptions)
      .pipe(tap(() => this.refreshSessionArea()));
  }

  unlinkArea(username: string): Observable<unknown> {
    return this.http.put(this.baseUrl, { username, area: null }, this.mainService.httpOptions).pipe(tap(() => this.refreshSessionAreaIfSelf([username])));
  }

  private refreshSessionAreaIfSelf(usernames: Array<string>): void {
    const me = (this.mainService.userToken?.username ?? "").toLowerCase();
    if (me && usernames.some((u) => u.toLowerCase() === me)) {
      this.refreshSessionArea();
    }
  }

  private refreshSessionArea(): void {
    this.mainService.refreshSessionArea?.().subscribe();
  }
}
